import { isUnderAttack } from "./chessUnderAttack";
import EY_S from "../../../../images/EY_S.png";
import PN_W from "../../../../images/PN_W.png";
import PN_B from "../../../../images/PN_B.png";

let allScope = [];
export function RookScopeMove(positionX, positionY, isWhiteTurn, blackPosition, whitePosition) {
	//Top
	for (let a = positionY + 1; a <= 8; a++) {
		const position = parseInt(`${positionX}${a}`); // DEBUG // console.log(position);
		if (ScopeMoveHighlight(position, isWhiteTurn, whitePosition, blackPosition) == "piece") break;
	}

	//Bottom
	for (let a = positionY - 1; a >= 1; a--) {
		const position = parseInt(`${positionX}${a}`); // DEBUG // console.log(position);
		if (ScopeMoveHighlight(position, isWhiteTurn, whitePosition, blackPosition) == "piece") break;
	}

	//Right
	for (let a = positionX + 1; a <= 8; a++) {
		const position = parseInt(`${a}${positionY}`); // DEBUG // console.log(position)
		if (ScopeMoveHighlight(position, isWhiteTurn, whitePosition, blackPosition) == "piece") break;
	}

	//Left
	for (let a = positionX - 1; a >= 1; a--) {
		const position = parseInt(`${a}${positionY}`); // DEBUG // console.log(position)
		if (ScopeMoveHighlight(position, isWhiteTurn, whitePosition, blackPosition) == "piece") break;
	}
}

export function KnightScopeMove(positionX, positionY, isWhiteTurn, blackPosition, whitePosition) {
	//Top Right
	if (positionX <= 7 && positionY <= 6) {
		const position = parseInt(`${positionX + 1}${positionY + 2}`); // DEBUG // console.log(position)
		ScopeMoveHighlight(position, isWhiteTurn, whitePosition, blackPosition);
	}

	//Top Left
	if (positionX >= 2 && positionY <= 6) {
		const position = parseInt(`${positionX - 1}${positionY + 2}`); // DEBUG // console.log(position)
		ScopeMoveHighlight(position, isWhiteTurn, whitePosition, blackPosition);
	}

	//Right Top
	if (positionX <= 6 && positionY <= 7) {
		const position = parseInt(`${positionX + 2}${positionY + 1}`); // DEBUG // console.log(position)
		ScopeMoveHighlight(position, isWhiteTurn, whitePosition, blackPosition);
	}

	//Right Bottom
	if (positionX <= 6 && positionY >= 2) {
		const position = parseInt(`${positionX + 2}${positionY - 1}`); // DEBUG // console.log(position)
		ScopeMoveHighlight(position, isWhiteTurn, whitePosition, blackPosition);
	}

	//Bottom Right
	if (positionX <= 7 && positionY >= 3) {
		const position = parseInt(`${positionX + 1}${positionY - 2}`); // DEBUG // console.log(position)
		ScopeMoveHighlight(position, isWhiteTurn, whitePosition, blackPosition);
	}

	//Bottom Left
	if (positionX >= 2 && positionY >= 3) {
		const position = parseInt(`${positionX - 1}${positionY - 2}`); // DEBUG // console.log(position)
		ScopeMoveHighlight(position, isWhiteTurn, whitePosition, blackPosition);
	}

	//Left Top
	if (positionX >= 3 && positionY <= 7) {
		const position = parseInt(`${positionX - 2}${positionY + 1}`); // DEBUG // console.log(position)
		ScopeMoveHighlight(position, isWhiteTurn, whitePosition, blackPosition);
	}

	//Left Bottom
	if (positionX >= 3 && positionY >= 2) {
		const position = parseInt(`${positionX - 2}${positionY - 1}`); // DEBUG // console.log(position)
		ScopeMoveHighlight(position, isWhiteTurn, whitePosition, blackPosition);
	}
}
export function BishopScopeMove(positionX, positionY, isWhiteTurn, blackPosition, whitePosition) {
	// Right Top
	for (let a = 1; a <= 8 && positionX !== 8 && positionY !== 8 && positionX + a !== 9 && positionY + a !== 9; a++) {
		const position = parseInt(`${positionX + a}${positionY + a}`); // DEBUG // console.log(position)

		if (ScopeMoveHighlight(position, isWhiteTurn, whitePosition, blackPosition) == "piece") break;
	}

	// Right Bottom
	for (let a = 1; a <= 8 && positionX !== 8 && positionY !== 1 && positionX + a !== 9 && positionY - a !== 0; a++) {
		const position = parseInt(`${positionX + a}${positionY - a}`); // DEBUG // console.log(position)

		if (ScopeMoveHighlight(position, isWhiteTurn, whitePosition, blackPosition) == "piece") break;
	}

	// Left Top
	for (let a = 1; a <= 8 && positionX !== 1 && positionY !== 8 && positionX - a !== 0 && positionY + a !== 9; a++) {
		const position = parseInt(`${positionX - a}${positionY + a}`); // DEBUG // console.log(position)

		if (ScopeMoveHighlight(position, isWhiteTurn, whitePosition, blackPosition) == "piece") break;
	}

	// Left Bottom
	for (let a = 1; a <= 8 && positionX !== 1 && positionY !== 1 && positionX - a !== 0 && positionY - a !== 0; a++) {
		const position = parseInt(`${positionX - a}${positionY - a}`); // DEBUG // console.log(position)

		if (ScopeMoveHighlight(position, isWhiteTurn, whitePosition, blackPosition) == "piece") break;
	}
}

export function KingScopeMove(
	positionX,
	positionY,
	isWhiteTurn,
	blackPosition,
	whitePosition,
	canWhiteCastle,
	canBlackCastle,
	whitePiece,
	blackPiece
) {
	//Top
	if (positionY !== 8) {
		const position = parseInt(`${positionX}${positionY + 1}`); // DEBUG // console.log(position)
		if (!isUnderAttack(isWhiteTurn, whitePosition, blackPosition, whitePiece, blackPiece, position))
			ScopeMoveHighlight(position, isWhiteTurn, whitePosition, blackPosition);
	}

	//Top Right
	if (positionX !== 8 && positionY !== 8) {
		const position = parseInt(`${positionX + 1}${positionY + 1}`); // DEBUG // console.log(position)
		if (!isUnderAttack(isWhiteTurn, whitePosition, blackPosition, whitePiece, blackPiece, position))
			ScopeMoveHighlight(position, isWhiteTurn, whitePosition, blackPosition);
	}

	//Right
	if (positionX !== 8) {
		const position = parseInt(`${positionX + 1}${positionY}`); // DEBUG // console.log(position)
		if (!isUnderAttack(isWhiteTurn, whitePosition, blackPosition, whitePiece, blackPiece, position))
			ScopeMoveHighlight(position, isWhiteTurn, whitePosition, blackPosition);
	}

	//Bottom  Right
	if (positionX !== 8 && positionY !== 1) {
		const position = parseInt(`${positionX + 1}${positionY - 1}`); // DEBUG // console.log(position)
		if (!isUnderAttack(isWhiteTurn, whitePosition, blackPosition, whitePiece, blackPiece, position))
			ScopeMoveHighlight(position, isWhiteTurn, whitePosition, blackPosition);
	}

	//Bottom
	if (positionY !== 1) {
		const position = parseInt(`${positionX}${positionY - 1}`); // DEBUG // console.log(position)
		if (!isUnderAttack(isWhiteTurn, whitePosition, blackPosition, whitePiece, blackPiece, position))
			ScopeMoveHighlight(position, isWhiteTurn, whitePosition, blackPosition);
	}

	//Bottom Left
	if (positionX !== 1 && positionY !== 1) {
		const position = parseInt(`${positionX - 1}${positionY - 1}`); // DEBUG // console.log(position)
		if (!isUnderAttack(isWhiteTurn, whitePosition, blackPosition, whitePiece, blackPiece, position))
			ScopeMoveHighlight(position, isWhiteTurn, whitePosition, blackPosition);
	}

	//Left
	if (positionX !== 1) {
		const position = parseInt(`${positionX - 1}${positionY}`); // DEBUG // console.log(position)
		if (!isUnderAttack(isWhiteTurn, whitePosition, blackPosition, whitePiece, blackPiece, position))
			ScopeMoveHighlight(position, isWhiteTurn, whitePosition, blackPosition);
	}

	//Left Top
	if (positionX !== 1 && positionY !== 8) {
		const position = parseInt(`${positionX - 1}${positionY + 1}`); // DEBUG // console.log(position)
		if (!isUnderAttack(isWhiteTurn, whitePosition, blackPosition, whitePiece, blackPiece, position))
			ScopeMoveHighlight(position, isWhiteTurn, whitePosition, blackPosition);
	}

	const canCastle = isWhiteTurn ? canWhiteCastle : canBlackCastle;
	// Castle Left
	if (canCastle[0] && positionX == 5) {
		// King and left rook hasn't moved
		const posKing = parseInt(`${positionX}${positionY}`);
		const posLeft01 = parseInt(`${positionX - 1}${positionY}`);
		const posLeft02 = parseInt(`${positionX - 2}${positionY}`);
		const posLeft03 = parseInt(`${positionX - 3}${positionY}`);
		// const squareKing = document.getElementById(`P${posKing}`);
		const squareLeft01 = document.getElementById(`P${posLeft01}`);
		const squareLeft02 = document.getElementById(`P${posLeft02}`);
		const squareLeft03 = document.getElementById(`P${posLeft03}`);
		if (squareLeft01.src === EY_S && squareLeft02.src === EY_S && squareLeft03.src === EY_S) {
			// square Left 1-3 is empty
			const atkLeft01 = isUnderAttack(isWhiteTurn, whitePosition, blackPosition, whitePiece, blackPiece, posLeft01);
			const atkLeft02 = isUnderAttack(isWhiteTurn, whitePosition, blackPosition, whitePiece, blackPiece, posLeft02);
			const atkLeft03 = isUnderAttack(isWhiteTurn, whitePosition, blackPosition, whitePiece, blackPiece, posLeft03);
			const atkKing = isUnderAttack(isWhiteTurn, whitePosition, blackPosition, whitePiece, blackPiece, posKing);
			if (!atkLeft01 && !atkLeft02 && !atkLeft03 && !atkKing) {
				allScope.push(parseInt(`${posLeft02}`));
				// squareLeft02.style.backgroundColor = "rgb(125, 125, 255)";
			}
			//  square Left 1-3 is not under attacked
		}
	}
	// Castle Right
	if (canCastle[1] && positionX == 5) {
		// King and right rook hasn't moved

		const posKing = parseInt(`${positionX}${positionY}`);
		const posRight01 = parseInt(`${positionX + 1}${positionY}`);
		const posRight02 = parseInt(`${positionX + 2}${positionY}`);
		const squareRight01 = document.getElementById(`P${posRight01}`);
		const squareRight02 = document.getElementById(`P${posRight02}`);
		if (squareRight01.src === EY_S && squareRight02.src === EY_S) {
			// square Right 1-3 is empty
			const atkRight01 = isUnderAttack(isWhiteTurn, whitePosition, blackPosition, whitePiece, blackPiece, posRight01);
			const atkRight02 = isUnderAttack(isWhiteTurn, whitePosition, blackPosition, whitePiece, blackPiece, posRight02);
			const atkKing = isUnderAttack(isWhiteTurn, whitePosition, blackPosition, whitePiece, blackPiece, posKing);
			if (!atkRight01 && !atkRight02 && !atkKing) {
				allScope.push(parseInt(`${posRight02}`));
				// squareRight02.style.backgroundColor = "rgb(125, 125, 255)";
			}
			// square Right 1-3 is not under attacked
		}
	}
}

export function PawnScopeMove(positionX, positionY, isWhiteTurn, blackPosition, whitePosition, lastHistory = "MO-37>35") {
	if (isWhiteTurn) {
		// Pawn Move
		const square01 = document.getElementById(`P${positionX}${positionY + 1}`); // DEBUG // console.log(`P${positionX}${(positionY+1)}`);
		if (square01.src === EY_S) {
			allScope.push(parseInt(`${positionX}${positionY + 1}`));
			// square01.style.backgroundColor = "rgb(0, 255, 0)";

			const square02 = document.getElementById(`P${positionX}${positionY + 2}`); // DEBUG // console.log(`P${positionX}${(positionY+2)}`);
			if (positionY === 2 && square02.src === EY_S) {
				allScope.push(parseInt(`${positionX}${positionY + 2}`));
				// square02.style.backgroundColor = "rgb(0, 255, 0)";
			}
		}

		// Pawn Attack
		if (positionX !== 8) {
			// DectectPiece(`P${positionX + 1}${positionY + 1}`, isWhiteTurn, blackPosition, whitePosition);
			const position = parseInt(`${positionX + 1}${positionY + 1}`); // DEBUG // console.log(position)
			const square = document.getElementById(`P${position}`); // DEBUG // console.log(`P${positionX}${(positionY-1)}`)
			if (square.src !== EY_S) ScopeMoveHighlight(position, isWhiteTurn, whitePosition, blackPosition);
		}
		if (positionX !== 1) {
			// DectectPiece(`P${positionX - 1}${positionY + 1}`, isWhiteTurn, blackPosition, whitePosition);
			const position = parseInt(`${positionX - 1}${positionY + 1}`); // DEBUG // console.log(position)
			const square = document.getElementById(`P${position}`); // DEBUG // console.log(`P${positionX}${(positionY-1)}`)
			if (square.src !== EY_S) ScopeMoveHighlight(position, isWhiteTurn, whitePosition, blackPosition);
		}

		// Pass pawn
		let moveDistance = parseInt(`${lastHistory[3]}${lastHistory[4]}`) - parseInt(`${lastHistory[6]}${lastHistory[7]}`);

		const squareLeft = document.getElementById(`P${positionX - 1}${positionY}`); // DEBUG // console.log(`P${positionX}${(positionY+1)}`);
		const squareTopLeft = document.getElementById(`P${positionX - 1}${positionY + 1}`); // DEBUG // console.log(`P${positionX}${(positionY+1)}`);
		const isSameLeftPosition = `${lastHistory[6]}${lastHistory[7]}` === `${positionX - 1}${positionY}`;
		if (squareLeft.src === PN_B && squareTopLeft.src === EY_S && moveDistance == 2 && isSameLeftPosition) {
			allScope.push(parseInt(`${positionX - 1}${positionY + 1}`));
			// squareTopLeft.style.backgroundColor = "rgb(255, 100, 100)";
		}

		const squareRight = document.getElementById(`P${positionX + 1}${positionY}`); // DEBUG // console.log(`P${positionX}${(positionY+1)}`);
		const squareTopRight = document.getElementById(`P${positionX + 1}${positionY + 1}`); // DEBUG // console.log(`P${positionX}${(positionY+1)}`);
		const isSameRightPosition = `${lastHistory[6]}${lastHistory[7]}` === `${positionX + 1}${positionY}`;
		if (squareRight.src === PN_B && squareTopRight.src === EY_S && moveDistance == 2 && isSameRightPosition) {
			allScope.push(parseInt(`${positionX + 1}${positionY + 1}`));
			// squareTopRight.style.backgroundColor = "rgb(255, 100, 100)";
		}
	} else {
		// Pawn Move
		const square01 = document.getElementById(`P${positionX}${positionY - 1}`); // DEBUG // console.log(`P${positionX}${(positionY-1)}`)
		if (square01.src === EY_S) {
			allScope.push(parseInt(`${positionX}${positionY - 1}`));
			// square01.style.backgroundColor = "rgb(0, 255, 0)";

			const square02 = document.getElementById(`P${positionX}${positionY - 2}`); // DEBUG // console.log(`P${positionX}${(positionY-2)}`);
			if (positionY === 7 && square02.src === EY_S) {
				allScope.push(parseInt(`${positionX}${positionY - 2}`));
				// square02.style.backgroundColor = "rgb(0, 255, 0)";
			}
		}

		// Pawn Attack
		if (positionX !== 8) {
			// DectectPiece(`P${positionX + 1}${positionY - 1}`, isWhiteTurn, blackPosition, whitePosition);
			const position = parseInt(`${positionX + 1}${positionY - 1}`); // DEBUG // console.log(position)
			const square = document.getElementById(`P${position}`); // DEBUG // console.log(`P${positionX}${(positionY-1)}`)
			if (square.src !== EY_S) ScopeMoveHighlight(position, isWhiteTurn, whitePosition, blackPosition);
		}
		if (positionX !== 1) {
			// DectectPiece(`P${positionX - 1}${positionY - 1}`, isWhiteTurn, blackPosition, whitePosition);
			const position = parseInt(`${positionX - 1}${positionY - 1}`); // DEBUG // console.log(position)
			const square = document.getElementById(`P${position}`); // DEBUG // console.log(`P${positionX}${(positionY-1)}`)
			if (square.src !== EY_S) ScopeMoveHighlight(position, isWhiteTurn, whitePosition, blackPosition);
		}

		// Pass pawn
		let moveDistance = parseInt(`${lastHistory[3]}${lastHistory[4]}`) - parseInt(`${lastHistory[6]}${lastHistory[7]}`);

		const squareLeft = document.getElementById(`P${positionX - 1}${positionY}`); // DEBUG // console.log(`P${positionX}${(positionY+1)}`);
		const squareTopLeft = document.getElementById(`P${positionX - 1}${positionY - 1}`); // DEBUG // console.log(`P${positionX}${(positionY+1)}`);
		const isSameLeftPosition = `${lastHistory[6]}${lastHistory[7]}` === `${positionX - 1}${positionY}`;
		if (squareLeft.src === PN_W && squareTopLeft.src === EY_S && moveDistance == -2 && isSameLeftPosition) {
			allScope.push(parseInt(`${positionX - 1}${positionY - 1}`));
			// squareTopLeft.style.backgroundColor = "rgb(255, 100, 100)";
		}
		const squareRight = document.getElementById(`P${positionX + 1}${positionY}`); // DEBUG // console.log(`P${positionX}${(positionY+1)}`);
		const squareTopRight = document.getElementById(`P${positionX + 1}${positionY - 1}`); // DEBUG // console.log(`P${positionX}${(positionY+1)}`);
		const isSameRightPosition = `${lastHistory[6]}${lastHistory[7]}` === `${positionX + 1}${positionY}`;
		if (squareRight.src === PN_W && squareTopRight.src === EY_S && moveDistance == -2 && isSameRightPosition) {
			allScope.push(parseInt(`${positionX + 1}${positionY - 1}`));
			// squareTopRight.style.backgroundColor = "rgb(255, 100, 100)";
		}
	}
}

function ScopeMoveHighlight(position, isWhiteTurn, whitePosition, blackPosition) {
	const square = document.getElementById(`P${position}`);
	// set the square backgroungColor to green if the square is empty
	if (square.src === EY_S) {
		allScope.push(position);
		// square.style.backgroundColor = "rgb(125, 125 , 255)";
	} else {
		// set the square backgroungColor to red if the square is opponents piece
		if (isWhiteTurn ? blackPosition.includes(position) : whitePosition.includes(position)) {
			allScope.push(position);
			// square.style.backgroundColor = "rgb(125, 125 ,255)";
		}
		return "piece";
	}
}

export function isOutOfMove(
	isWhiteTurn,
	whitePosition,
	blackPosition,
	whitePiece,
	blackPiece,
	canWhiteCastle,
	canBlackCastle,
	lastHistory
) {
	// console.log(isWhiteTurn, whitePosition, blackPosition, whitePiece, blackPiece, canWhiteCastle, canBlackCastle, lastHistory);
	// isWhiteTurn = !isWhiteTurn;
	allScope = [];
	let pieces = isWhiteTurn ? whitePiece : blackPiece;
	let position = isWhiteTurn ? whitePosition : blackPosition;

	pieces.forEach((piece, index) => {
		// Checking if the piece has not been captured
		if (typeof position[index] === "number") {
			const positionX = parseInt(`${position[index]}`[0]);
			const positionY = parseInt(`${position[index]}`[1]);

			switch (piece) {
				case "RK_B":
				case "RK_W":
					RookScopeMove(positionX, positionY, isWhiteTurn, blackPosition, whitePosition); // DEBUG // console.log("ROOK:", positionX, positionY);
					break;
				case "KT_B":
				case "KT_W":
					KnightScopeMove(positionX, positionY, isWhiteTurn, blackPosition, whitePosition); // DEBUG // console.log("KNIGHT:", positionX, positionY);
					break;
				case "BP_B":
				case "BP_W":
					BishopScopeMove(positionX, positionY, isWhiteTurn, blackPosition, whitePosition); // DEBUG // console.log("BISHOP:", positionX, positionY);
					break;
				case "QN_B":
				case "QN_W":
					RookScopeMove(positionX, positionY, isWhiteTurn, blackPosition, whitePosition); // DEBUG // console.log("QUEEN:", positionX, positionY);
					BishopScopeMove(positionX, positionY, isWhiteTurn, blackPosition, whitePosition);
					break;
				case "KG_B":
				case "KG_W":
					KingScopeMove(
						positionX,
						positionY,
						isWhiteTurn,
						blackPosition,
						whitePosition,
						canWhiteCastle,
						canBlackCastle,
						whitePiece,
						blackPiece
					); // DEBUG // console.log("KING:", positionX, positionY, );
					break;
				case "PN_B":
				case "PN_W":
					PawnScopeMove(positionX, positionY, isWhiteTurn, blackPosition, whitePosition, lastHistory); // DEBUG // console.log("PAWN:", positionX, positionY, isWhiteTurn);
					break;
			}
		}
	});
	// DEBUG
	// console.log(allScope, allScope.length);
	// allScope.forEach(item => { console.log(item);document.getElementById(`P${item}`).style.backgroundColor = "rgb(125, 125, 255)";});
	if (allScope.length == 0) return true;
	else return false;
}
